import React, { useState } from 'react';

import './project-actions-dropdown.styles.scss';

import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ProjectActionsDropdown = ({
  onSelectComplete, 
  onSelectArchive, 
  onSelectReopen, 
  status, 
  onSelectEdit,
  project,
  projectEdit,
  handleToggle, 
  show,
  labels
}) => {

    const [tooltip, setTooltip] = useState(false);

    return (
        <div className='actions-dropdown-container project-actions-dropdown'>
            <Dropdown show={show} onToggle={handleToggle}>

              {projectEdit ?

                <OverlayTrigger
                    placement="bottom-end"
                    trigger={['hover','hover']}
                    show={tooltip && !show}
                    onToggle={val => setTooltip(val)}
                    overlay={<Tooltip> More Actions </Tooltip>}>
                    <Dropdown.Toggle className="ghost-button">
                    </Dropdown.Toggle>
                </OverlayTrigger>
                  :
                  <OverlayTrigger
                    placement="bottom-end"
                    overlay={
                      <Tooltip className="no-permission-tooltip">You don't have permission to take action on this project.</Tooltip>
                    }
                  >
                    <div style={{width:"32px", height:"32px"}}>
                      <Dropdown.Toggle disabled className="ghost-button" style={{pointerEvents:'none'}}>
                      </Dropdown.Toggle>
                    </div>
                  </OverlayTrigger>
              }
                <Dropdown.Menu className="edit-dropdown-menu-container">
                    {status !== 2 && status !== 0 && <Dropdown.Item onClick={e => onSelectComplete(e)} className="edit-dropdown-menu-item" >
                        <span className="edit-dropdown-menu-item-name">
                            <div className="icon" style={{"left": "0px "}} id='complete'></div>
                            <div className="action-text" >Complete {labels?.ProjectSingular ?? "Project"}</div>
                        </span>
                    </Dropdown.Item>
                    }
                    {status !== 1 && <Dropdown.Item onClick={e => onSelectReopen(e, (status === 0 ? 'Unarchive' : 'Reopen'))} className="edit-dropdown-menu-item">       
                        <span className="edit-dropdown-menu-item-name">
                            <div className="icon" style={{"left": "0px"}} id={status === 0 ? 'unarchive' : 'reopen'}></div>
                            <div className="action-text" >{status === 0 ? `Unarchive ${labels?.ProjectSingular ?? "Project"}` : `Reopen ${labels?.ProjectSingular ?? "Project"}`}</div>
                        </span>
                    </Dropdown.Item>
                    }
                    {(status === 1 || status == 2) && <Dropdown.Item onClick={e => onSelectArchive(e)} className="edit-dropdown-menu-item">       
                        <span className="edit-dropdown-menu-item-name">
                            <div className="icon" style={{"left": "0px"}} id='archive'></div>
                            <div className="action-text" >Archive {labels?.ProjectSingular ?? "Project"}</div>
                        </span>
                    </Dropdown.Item>}
                    {!projectEdit ? "" :
                      <Dropdown.Item onClick={e => onSelectEdit(e)} className="edit-dropdown-menu-item">
                      <span className="edit-dropdown-menu-item-name">
                          <div className="icon" style={{"left": "0px"}} id="edit"></div>
                          <div className="action-text" >Edit {labels?.ProjectSingular ?? "Project"}</div>
                      </span>
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default ProjectActionsDropdown;
